export enum MarketplaceTradePurchaseStatus
{
    Pending = 1,
    Success = 2,
    Failed = 3
}